import { Control, FormState } from 'react-hook-form';
import { Fragment } from 'react/jsx-runtime';
import { useRef } from 'react';
import { FlexContainer } from '../../containers/ContentContainers/FlexContainer';
import { FormConfig } from './formBuilder.types';
import { FormBuilderItem } from './FormBuilderItem';
import { getFormBuilderItemKey } from './formBuilderKey.util';
import {
  FormBuilderLabel,
  FormBuilderGroup as Group,
} from './FormBuilderLayout';
import { useWidth } from '../../utilities/useWidth.hook';

type FormBuilderProps<T> = {
  config: FormConfig<T>;
  control: Control<T>;
  formState?: FormState<T>;
  disabled?: boolean;
};

export const FormBuilder = <T,>({
  config,
  control,
  formState,
  disabled,
}: FormBuilderProps<T>) => {
  const containerRef = useRef(null);
  const width = useWidth(containerRef);

  return (
    <FlexContainer ref={containerRef} direction="column" width="100%" height="auto">
      {config.map((item, index) => {
        const itemKey = getFormBuilderItemKey(item, index);

        if (!item) {
          return <Fragment key={itemKey} />;
        }
        const isArray = Array.isArray(item);

        if (!isArray && item.type === 'label') {
          return (
            <FormBuilderLabel key={itemKey}>{item.label}</FormBuilderLabel>
          );
        }
        const Component = isArray || item.type === 'group' ? Fragment : Group;
        return (
          <Component key={itemKey}>
            <FormBuilderItem
              formItem={item}
              control={control}
              formState={formState}
              formWidth={width}
              disabled={disabled}
            />
          </Component>
        );
      })}
    </FlexContainer>
  );
};
